import { useLayoutEffect, useRef, useState } from "react";

/**
 * Hook to get the height (in px) of an element as it resizes
 */
export function useElementHeight<TElement extends HTMLElement>() {
  const ref = useRef<TElement | null>(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const element = ref.current;

    if (!element) {
      return;
    }

    const updateHeight = () => {
      setHeight(element.getBoundingClientRect().height);
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return { ref, height };
}
